export default __webpack_public_path__ + "static/media/00.61539da7.jpg";